import { WIDEN_DEFAULT_IMAGE_TYPE } from '@hub/libs/constants';
import { WidenUtil } from '@hub/libs/widen-utils';
import { WidenImageConfig } from '@hub/models/widen-image-config';

export interface WidenVideoProps {
  shortCode: string;
  filename: string;
  posterWidth?: number;
  posterHeight?: number;
  format?: 'mp4' | undefined;
  hd?: boolean;
  title?: string;
  'data-testid'?: string;
}

export const WidenVideo = ({
  shortCode,
  format = 'mp4',
  filename,
  hd = true,
  posterHeight = 240,
  posterWidth = 320,
  title,
  'data-testid': dataTestId,
}: WidenVideoProps) => {
  const videoSrc = `${WidenUtil.getWidenCDNUrl(new WidenImageConfig(shortCode, filename))}${hd ? '?quality=hd' : ''}`;

  const posterFilename = WidenUtil.replaceFileExtension(filename, WIDEN_DEFAULT_IMAGE_TYPE);
  const posterSrc = WidenUtil.getWidenCDNUrl(
    new WidenImageConfig(shortCode, posterFilename || filename, posterWidth, posterHeight)
  );

  return (
    <video className="flex-col" controls poster={posterSrc} title={title} data-testid={dataTestId}>
      <source src={videoSrc} type={`video/${format}`} />
    </video>
  );
};
